import { Helmet } from "react-helmet";
import Section1 from "./Section1";
import Section2 from "./Section2";
import Section3 from "./Section3";
import Section4 from "./Section4";
import Section5 from "./Section5";
import Section6 from "./Section6";
import Section7 from "./Section7";

export default function SocialMediaMarketing() {
  return (
    <div className="Social-Media-Marketing pt-[160px] sm:pt-0 ">
      <Helmet>
        <title>Professional Digital Marketing Services in Dubai | Mean3</title>
        <meta
        name="description"
        content="Boost your business with expert digital marketing services in Dubai. SEO, PPC, social media,and more by Mean3. Contact us today!"
        />
      </Helmet>
      <Section1 />
      <Section5 />
      <Section6 />
      <Section2 />
      <Section7 />
      <Section3 />
      <Section4 />
    </div>
  );
}
